import React from 'react';
import { Reveal } from '../ui/Reveal';
import { FRECUENCIA_IMG } from '../../data/retiro';
export function Frecuencia() {
  return <section className="relative w-full overflow-hidden" data-id="element-149" data-mp="32hpt6kmt3jd1">
      <div className="absolute inset-0" data-id="element-150" data-mp="3giipnawo4ois">
        <img src={FRECUENCIA_IMG} alt="Laguna en calma bajo un cielo estrellado con la Vía Láctea reflejada en el agua" className="h-full w-full object-cover" data-id="element-151" data-mp="3ghh3aaa7cflr" />
        <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(20,17,15,0.72)'
      }} data-id="element-152" data-mp="2orcjodu9nwll" />
      </div>

      <div className="relative mx-auto max-w-3xl px-5 py-28 text-center sm:px-8 sm:py-36" data-id="element-153" data-mp="2xjoaw1x7fo2m">
        <Reveal data-id="element-154" data-mp="2ssodkvk6b3zl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.3em]" style={{
          color: 'var(--jasmine)'
        }} data-id="element-155" data-mp="2ss67763sr9dy">
            Por qué vamos
          </span>
          <h2 className="mt-6 font-heading text-3xl font-light leading-snug text-white sm:text-[2.75rem]" data-id="element-156" data-mp="20z5sru7b8htk">
            Hay lugares que te encuentran
          </h2>
          <div className="mt-8 space-y-6 text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-157" data-mp="37yitcz3xeruw">
            <p data-id="element-158" data-mp="3crbxbkrklw5x">
              Hay invitaciones que no vienen de la mente racional. No aparecen
              en una lista de pendientes ni en un plan de fin de año: llegan
              como un impulso que no sabes explicar y que, sin embargo,
              reconoces.
            </p>
            <p data-id="element-159" data-mp="2ozwp5bd44kmr">
              Bacalar es una de esas invitaciones. Los mayas la llamaron
              "Bak'halal", el lugar rodeado de carrizos; el agua guarda memoria
              de estromatolitos que llevan miles de millones de años sosteniendo
              vida. No vamos a un destino: vamos a una frecuencia.
            </p>
            <p className="font-heading text-xl font-light italic leading-relaxed sm:text-2xl" style={{
            color: 'var(--jasmine)'
          }} data-id="element-160" data-mp="9922us06i1rd">
              "Y esta es la frecuencia que te convoca. Si la estás sintiendo, ya
              empezó."
            </p>
            <p data-id="element-161" data-mp="25et4kf1kdbnb">
              Por eso vamos: porque cuando un lugar te llama y respondes, algo
              en tu vida se reordena antes de que llegues. Lo demás — el agua,
              el fuego, el sonido, el nudo — solo viene a confirmarlo.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}